import { defineComponent, ref, h } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

/**
 * Avatar
 */
export default defineComponent({
  components: { OIcon },
  props: {
    /**
     * background color of fallback avatar
     */
    bg: {
      type: String,
      default: 'bg-alpha-10',
    },
    src: {
      type: String,
      required: true,
    },
    srcset: {
      type: String,
    },
    sizes: {
      type: String,
    },
    alt: {
      type: String,
      default: '',
    },
    /** rounded borders */
    rounded: {
      type: Boolean,
      default: false,
    },
    // image bulunamazsa fallback için gösterilen icon classları
    // icon boyutu değiştirmek için text stilleri kullanılabilir
    fallbackClass: {
      type: String,
      default: 'text-xl',
    },
  },
  setup(props) {
    const showFallbackAvatar = ref(false);

    const onLoad = () => {
      showFallbackAvatar.value = false;
    };

    const onError = () => {
      showFallbackAvatar.value = true;
    };

    return () => {
      const image = h('img', {
        // todo vue3: attrs sil
        attrs: {
          src: props.src,
          alt: props.alt,
          srcset: props.srcset,
          sizes: props.sizes,
        },
        on: {
          load: onLoad,
          error: onError,
        },
        class: `object-cover flex-shrink-0 ${props.rounded ? 'rounded-full' : ''}`,
      });

      const fallbackImage = h(
        'div',
        {
          class: ` flex-shrink-0 u-center  ${props.rounded ? 'rounded-full' : ''} ${props.fallbackClass} ${props.bg}`,
        },
        [h(OIcon, { props: { icon: 'user' }, class: 'text-white' })]
      );

      const renderImage = showFallbackAvatar.value ? fallbackImage : image;
      return renderImage;
    };
  },
});
